import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from './api.service'

@Injectable()
export class OportunidadeTratamentosService {
	constructor(private apiService: ApiService) {}

	getAll(filtro?): Observable<any> {
		const url = `/oportunidade-tratamentos`
		return this.apiService.get(url, filtro)
	}

	get(id: number): Observable<any> {
		const url = `/oportunidade-tratamentos/${id}`
		return this.apiService.get(url)
	}

	post(form): Observable<any> {
		return this.apiService.post('/oportunidade-tratamentos', form)
	}

	put(id: number, form): Observable<any> {
		form._method = 'PUT'
		return this.apiService.post('/oportunidade-tratamentos/' + id, form)
	}

	delete(id): Observable<any> {
		return this.apiService.delete('/oportunidade-tratamentos/' + id)
	}
}
